export const FONT_FAMILY = "Roboto, Arial, Helvetica, sans-serif";
export const VALID_USERNAMES = [
  "standard_user",
  "locked_out_user",
  "problem_user",
  "performance_glitch_user",
  "error_user",
  "visual_user",
];
export const VALID_PASSWORD = "secret_sauce";
export const ROUTES = {
  LOGIN: "/",
  INVENTORY: "/inventory.html",
  INVENTORY_LONG: "/inventory-long.html",
  INVENTORY_LIST: "/inventory-item.html",
  CART: "/cart.html",
  CHECKOUT_STEP_ONE: "/checkout-step-one.html",
  CHECKOUT_STEP_TWO: "/checkout-step-two.html",
  CHECKOUT_COMPLETE: "/checkout-complete.html",
};
export const CART_CONTENTS = "cart-contents";
export const SESSION_USERNAME = "session-username";
